import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../utils/LoadingSpinner';

const StatsHourlyChart = ({ data, loading }) => {
	if (loading) {
		return <LoadingSpinner loadingMsg='Loading hourly stats' />;
	}

	if (!data || data.length === 0) {
		return <p className='text-center text-muted mt-3'>No hourly data available</p>;
	}

	const chartData = data.map(item => ({
		hour: item.hour?.split(' ')[1] || item.hour,
		total: item.total || 0,
		errors: item.errors || 0
	}));

	return (
		<ResponsiveContainer width='100%' height={350}>
			<BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
				<CartesianGrid strokeDasharray='3 3' />
				<XAxis dataKey='hour' fontSize={12} />
				<YAxis />
				<Tooltip />
				<Legend />
				<Bar dataKey='total' fill='#0d6efd' name='Total Jobs' />
				<Bar dataKey='errors' fill='#dc3545' name='Errors' />
			</BarChart>
		</ResponsiveContainer>
	);
}

StatsHourlyChart.propTypes = {
	data: PropTypes.array,
	loading: PropTypes.bool
}

export default StatsHourlyChart;
